import React from 'react';
// import classnames from 'classnames';
import PropTypes from 'prop-types';

const TextFieldGroupProfile = ({
  field, value, label, id, error, type, onChange, checkUserExists, disabled, classFullLegal, show
}) => (
    <span className={`${classFullLegal}`}>
      <label className="active" htmlFor={label}>{label}</label>

      <input
        onChange={onChange}
        onBlur={checkUserExists}
        value={value}
        type={type}
        name={field}
        id={id}
        placeholder={show ? '' : label}
        className="form-control validate"
        disabled={disabled}
      // autoComplete="-"
      />

      {error && <span className="help-block invalid ">{error}</span>}
    </span>
  );

TextFieldGroupProfile.propTypes = {
  field: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string,
  error: PropTypes.any,
  type: PropTypes.string,
  classFullLegal: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.any,
  checkUserExists: PropTypes.func,
};

TextFieldGroupProfile.defaultProps = {
  type: 'text',
  disabled: false,
  classFullLegal: '',
  id: '',
  show: false
};

export default TextFieldGroupProfile;
